module.exports = __webpack_public_path__ + "static/img/rz(1).8706ebf2.jpg";